import { Link } from 'react-router-dom'
import React from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import Accordion from 'react-bootstrap/Accordion';
import OffcanvasBody from 'react-bootstrap/OffcanvasBody'
import axios from 'axios';
import { 
 FaFileInvoice, FaTrash, FaShoppingCart, 
  FaChartBar, FaFileExcel, FaBoxes, FaClipboardList,
  FaUsers, FaUniversity, FaBuilding, FaLocationArrow,
  FaCity, FaProductHunt, FaBarcode, FaShoppingBag,
  FaFileAlt, FaCog, FaMoneyBillWave, 
  FaUserPlus, FaWallet, FaStore,
  FaTag,  FaFilePdf, FaChartLine,
  FaReceipt, FaCreditCard, FaListAlt, 
 FaPlus
} from 'react-icons/fa';

function Sidebar(props) {

  const handleClose = () => {
    props.onChildOffcanClose(false);
  }

  const handleExportUser = () => {
    axios({
      url: 'api/export/user/excel',
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'users.xlsx');
      document.body.appendChild(link);
      link.click();
      handleClose();
    });
  }

  const handlePbalanceReport = () => {
    axios({
      url: 'api/pbalance',
      method: 'get',
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
      handleClose();
    });
  }

  const handleOverallRecievableBySalesman = () => {
    axios({
      url: 'api/overallrecievablebysalesman',
      method: 'get',
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
      handleClose();
    });
  }

  // Styles
  const styles = {
    sidebarHeader: {
      background: 'linear-gradient(135deg, #dc3545 0%, #c0392b 100%)',
      color: 'white',
      padding: '20px 25px',
      borderBottom: 'none',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    headerIcon: {
      fontSize: '28px',
      color: 'rgba(255,255,255,0.9)',
    },
    headerTitle: {
      fontSize: '20px',
      fontWeight: '700',
      margin: 0,
      letterSpacing: '0.5px',
    },
    headerSubtitle: {
      fontSize: '12px',
      opacity: 0.8,
      margin: 0,
      fontWeight: '400',
    },
    closeBtn: {
      position: 'absolute',
      right: '15px',
      top: '15px',
      background: 'rgba(255,255,255,0.15)',
      border: 'none',
      color: 'white',
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontSize: '16px',
    },
    accordionItem: {
      border: 'none',
      marginBottom: '6px',
      borderRadius: '10px',
      overflow: 'hidden',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      transition: 'all 0.3s ease',
    },
    accordionHeader: {
      background: 'white',
      padding: '12px 18px',
      borderRadius: '10px',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      transition: 'all 0.3s ease',
      fontSize: '15px',
      fontWeight: '600',
      color: '#2c3e50',
    },
    accordionHeaderHover: {
      background: '#fff5f5',
    },
    accordionIcon: {
      fontSize: '18px',
      color: '#dc3545',
      width: '24px',
      textAlign: 'center',
    },
    accordionBody: {
      padding: '8px 12px',
      background: '#fafafa',
    },
    menuLink: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '10px 14px',
      borderRadius: '8px',
      textDecoration: 'none',
      color: '#2c3e50',
      transition: 'all 0.3s ease',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      position: 'relative',
    },
    menuLinkHover: {
      background: '#fff5f5',
      transform: 'translateX(4px)',
      color: '#dc3545',
    },
    menuIcon: {
      fontSize: '16px',
      color: '#6c757d',
      width: '20px',
      textAlign: 'center',
      transition: 'all 0.3s ease',
    },
    menuIconActive: {
      color: '#dc3545',
    },
    menuDivider: {
      height: '1px',
      background: 'linear-gradient(to right, transparent, #e0e0e0, transparent)',
      margin: '4px 12px',
      border: 'none',
    },
    menuBadge: {
      background: '#dc3545',
      color: 'white',
      fontSize: '10px',
      padding: '2px 8px',
      borderRadius: '12px',
      marginLeft: 'auto',
      fontWeight: '600',
    },
    offcanvasBody: {
      padding: '12px 16px',
      background: '#f8f9fa',
    },
    footer: {
      padding: '16px 20px',
      borderTop: '1px solid #e0e0e0',
      background: 'white',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '8px',
    },
    footerText: {
      fontSize: '12px',
      color: '#888',
      margin: 0,
    },
    footerVersion: {
      fontSize: '11px',
      color: '#aaa',
      fontWeight: '600',
      background: '#f0f0f0',
      padding: '3px 10px',
      borderRadius: '12px',
    },
  };

  // Menu items configuration
  const menuSections = [
    {
      id: 'reports',
      title: 'Reports',
      icon: <FaChartBar />,
      items: [
        { to: '/allsaleinvoices', label: 'All Sale Invoices', icon: <FaFileInvoice /> },
        { to: '/alldeletedsaleinvoices', label: 'All Deleted Sale Invoices', icon: <FaTrash /> },
        { to: 'all/purchase/invoices', label: 'All Purchase Invoices', icon: <FaShoppingCart /> },
        { to: '/dailybrandsalereport', label: 'Daily Sale Report', icon: <FaChartBar /> },
        { 
          onClick: handleExportUser, 
          label: 'Export Users Detail In Excel', 
          icon: <FaFileExcel /> 
        },
        { to: 'stockbystore', label: 'Closing Stock', icon: <FaBoxes /> },
        { to: 'stockstatus', label: 'Stock Status', icon: <FaClipboardList /> },
        { to: 'ledger', label: 'Client Ledger', icon: <FaUsers /> },
        { to: 'duelist', label: 'Due/Recovery List', icon: <FaMoneyBillWave /> },
        { 
          onClick: handlePbalanceReport, 
          label: 'Overall Receivable By Customer', 
          icon: <FaFilePdf /> 
        },
        { 
          onClick: handleOverallRecievableBySalesman, 
          label: 'Overall Receivable By Salesman', 
          icon: <FaFilePdf /> 
        },
        { to: 'batchlistinvoices', label: 'Batch List Invoices', icon: <FaListAlt /> },
        { to: 'sectorsalepbalance', label: 'Region Sale With Previous Balance', icon: <FaLocationArrow /> },
        { to: 'subsectorsalepbalance', label: 'Location Sale With Previous Balance', icon: <FaCity /> },
        { to: 'salesummerybybrand', label: 'Profit Report By Sale', icon: <FaChartLine /> },
        { to: '/due/sector/report', label: 'Region Due Report', icon: <FaLocationArrow /> },
        { to: '/brand/purchase/report', label: 'Purchase Report', icon: <FaShoppingBag /> },
        { to: '/monthlyexpensereport', label: 'Monthly Expense Report', icon: <FaReceipt /> },
      ]
    },
    {
      id: 'registration',
      title: 'Registration Module',
      icon: <FaUserPlus />,
      items: [
        { to: '/userslist', label: 'Add Users', icon: <FaUsers /> },
      ]
    },
    {
      id: 'bank',
      title: 'Bank Detail',
      icon: <FaUniversity />,
      items: [
        { to: 'openingbalance', label: 'Add Opening Balance', icon: <FaWallet /> },
        { to: 'recievepayment', label: 'Recieve Payments', icon: <FaCreditCard /> },
      ]
    },
    {
      id: 'company',
      title: 'Company Detail',
      icon: <FaBuilding />,
      items: [
        { to: 'systemstore', label: 'Add Store', icon: <FaStore /> },
        { to: 'systeminvoice', label: 'Add Invoice Detail', icon: <FaFileInvoice /> },
      ]
    },
    {
      id: 'location',
      title: 'Location Detail',
      icon: <FaLocationArrow />,
      items: [
        { to: 'addsector', label: 'Add Region', icon: <FaLocationArrow /> },
        { to: 'addsubsector', label: 'Add City', icon: <FaCity /> },
        { to: 'assignsector', label: 'Assign City To Customer', icon: <FaUsers /> },
      ]
    },
    {
      id: 'products',
      title: 'Products Management',
      icon: <FaProductHunt />,
      items: [
        { to: '/add/category', label: 'Add Category', icon: <FaTag /> },
        { to: '/add/product', label: 'Add Product', icon: <FaProductHunt /> },
        { to: '/gen/barcode', label: 'Gen Barcode', icon: <FaBarcode /> },
      ]
    },
    {
      id: 'purchase',
      title: 'Purchase Management',
      icon: <FaShoppingCart />,
      items: [
        { to: '/purchase/entry/invoice', label: 'Add Purchase Invoice', icon: <FaPlus /> },
        { to: 'all/purchase/invoices', label: 'All Purchase Invoices', icon: <FaListAlt /> },
      ]
    },
    {
      id: 'special',
      title: 'Special Invoices',
      icon: <FaFileAlt />,
      items: [
        { to: 'autoname', label: 'Special Invoice Names', icon: <FaTag /> },
        { to: 'settingautoname', label: 'Setting Special Invoice', icon: <FaCog /> },
      ]
    },
    {
      id: 'expense',
      title: 'Expense Sheet',
      icon: <FaMoneyBillWave />,
      items: [
        { to: '/expensesheet', label: 'Add Monthly Expense', icon: <FaPlus /> },
      ]
    },
  ];

  return (
    <div>
      <Offcanvas 
        show={props.show} 
        className='animated fadeInDown' 
        onHide={handleClose} 
        placement='end' 
        scroll='false'
        style={{ width: '380px' }}
      >
        {/* Custom Header */}
        <div style={styles.sidebarHeader}>
          <FaStore style={styles.headerIcon} />
          <div>
            <h4 style={styles.headerTitle}>Menu</h4>
            <p style={styles.headerSubtitle}>Navigate through modules</p>
          </div>
          <button 
            style={styles.closeBtn}
            onClick={handleClose}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.25)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}
          >
            ✕
          </button>
        </div>

        <OffcanvasBody style={styles.offcanvasBody}>
          <Accordion defaultActiveKey="reports">
            {menuSections.map((section) => (
              <Accordion.Item 
                key={section.id} 
                eventKey={section.id}
                style={styles.accordionItem}
              >
                <Accordion.Header
                  style={styles.accordionHeader}
                  className="accordion-header-custom"
                >
                  <span style={styles.accordionIcon}>{section.icon}</span>
                  {section.title}
                </Accordion.Header>
                <Accordion.Body style={styles.accordionBody}>
                  {section.items.map((item, index) => (
                    <React.Fragment key={index}>
                      {item.to ? (
                        <Link
                          to={item.to}
                          onClick={handleClose}
                          style={styles.menuLink}
                          className="menu-link-custom"
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#fff5f5';
                            e.currentTarget.style.transform = 'translateX(4px)';
                            e.currentTarget.style.color = '#dc3545';
                            const icon = e.currentTarget.querySelector('.menu-icon');
                            if (icon) icon.style.color = '#dc3545';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'transparent';
                            e.currentTarget.style.transform = 'translateX(0)';
                            e.currentTarget.style.color = '#2c3e50';
                            const icon = e.currentTarget.querySelector('.menu-icon');
                            if (icon) icon.style.color = '#6c757d';
                          }}
                        >
                          <span className="menu-icon" style={styles.menuIcon}>{item.icon}</span>
                          {item.label}
                        </Link>
                      ) : (
                        <div
                          onClick={item.onClick}
                          style={styles.menuLink}
                          className="menu-link-custom"
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#fff5f5';
                            e.currentTarget.style.transform = 'translateX(4px)';
                            e.currentTarget.style.color = '#dc3545';
                            const icon = e.currentTarget.querySelector('.menu-icon');
                            if (icon) icon.style.color = '#dc3545';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'transparent';
                            e.currentTarget.style.transform = 'translateX(0)';
                            e.currentTarget.style.color = '#2c3e50';
                            const icon = e.currentTarget.querySelector('.menu-icon');
                            if (icon) icon.style.color = '#6c757d';
                          }}
                        >
                          <span className="menu-icon" style={styles.menuIcon}>{item.icon}</span>
                          {item.label}
                        </div>
                      )}
                      {index < section.items.length - 1 && <hr style={styles.menuDivider} />}
                    </React.Fragment>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </OffcanvasBody>

        {/* Footer */}
        <div style={styles.footer}>
          <span style={styles.footerText}>© 2024 Restaurant POS</span>
          <span style={styles.footerVersion}>v2.0.0</span>
        </div>
      </Offcanvas>

      {/* Internal CSS */}
      <style>{`
        /* Offcanvas Custom Styles */
        .offcanvas {
          box-shadow: -10px 0 40px rgba(0,0,0,0.1);
        }
        
        .offcanvas-header {
          padding: 0 !important;
        }
        
        .offcanvas-body {
          padding: 0 !important;
        }
        
        /* Accordion Custom Styles */
        .accordion-header-custom {
          background: white;
          padding: 12px 18px;
          border-radius: 10px;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 12px;
          transition: all 0.3s ease;
          font-size: 15px;
          font-weight: 600;
          color: #2c3e50;
        }
        
        .accordion-header-custom:hover {
          background: #fff5f5;
        }
        
        .accordion-header-custom .accordion-button {
          background: transparent !important;
          box-shadow: none !important;
          padding: 0 !important;
          font-weight: 600;
          color: #2c3e50;
        }
        
        .accordion-header-custom .accordion-button::after {
          filter: brightness(0.5);
        }
        
        .accordion-header-custom .accordion-button:not(.collapsed) {
          color: #dc3545;
        }
        
        .accordion-header-custom .accordion-button:not(.collapsed)::after {
          filter: brightness(0) invert(0.3) sepia(1) hue-rotate(-10deg) saturate(5);
        }
        
        .accordion-item {
          border: none !important;
          margin-bottom: 6px !important;
          border-radius: 10px !important;
          overflow: hidden !important;
          box-shadow: 0 2px 8px rgba(0,0,0,0.06) !important;
          transition: all 0.3s ease !important;
        }
        
        .accordion-item:hover {
          box-shadow: 0 4px 16px rgba(0,0,0,0.1) !important;
        }
        
        .accordion-button {
          background: white !important;
          box-shadow: none !important;
        }
        
        .accordion-button:focus {
          box-shadow: none !important;
          border-color: transparent !important;
        }
        
        .accordion-body {
          padding: 8px 12px !important;
          background: #fafafa !important;
        }
        
        /* Menu Link Styles */
        .menu-link-custom {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          padding: 10px 14px !important;
          border-radius: 8px !important;
          text-decoration: none !important;
          color: #2c3e50 !important;
          transition: all 0.3s ease !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          cursor: pointer !important;
          position: relative !important;
        }
        
        .menu-link-custom:hover {
          background: #fff5f5 !important;
          transform: translateX(4px) !important;
          color: #dc3545 !important;
        }
        
        .menu-link-custom .menu-icon {
          font-size: 16px !important;
          color: #6c757d !important;
          width: 20px !important;
          text-align: center !important;
          transition: all 0.3s ease !important;
        }
        
        .menu-link-custom:hover .menu-icon {
          color: #dc3545 !important;
        }
        
        /* Responsive Styles */
        @media (max-width: 576px) {
          .offcanvas {
            width: 100% !important;
          }
          
          .offcanvas-header {
            padding: 15px 20px !important;
          }
          
          .offcanvas-header h5 {
            font-size: 18px !important;
          }
          
          .accordion-header-custom {
            font-size: 14px !important;
            padding: 10px 14px !important;
          }
          
          .menu-link-custom {
            font-size: 13px !important;
            padding: 8px 12px !important;
          }
        }
        
        /* Scrollbar Styling */
        .offcanvas-body::-webkit-scrollbar {
          width: 4px;
        }
        
        .offcanvas-body::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        
        .offcanvas-body::-webkit-scrollbar-thumb {
          background: #dc3545;
          border-radius: 10px;
        }
        
        .offcanvas-body::-webkit-scrollbar-thumb:hover {
          background: #c0392b;
        }
      `}</style>
    </div>
  )
}

export default Sidebar